<template>
  <div>
    <h5 class="mb-4 font-weight-bold">
      {{ $t('signin.account.title') }}
    </h5>

    <SignInForm
      type="account"
      :signin-options="signinOptions"
      :email-account="emailAccount"
      :login-signup="loginSignup"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import SignInForm from './partials/SignInForm.vue'
import { useRootStore } from 'client/stores/root'

export default {
  components: {
    SignInForm
  },
  computed: {
    ...mapState(useRootStore, {
      signinOptions: state => state.__features.signin_options,
      emailAccount: state => state.__features.email_account,
      loginSignup: state => state.__features.login_signup
    })
  }
}
</script>
